<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <app-data
          titulo="Información del Canal"
          :datos="canalDatos">
        </app-data>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Datos del Canal</b-dropdown-item>
          <b-dropdown-item @click.stop="goList">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Data from  '../shared/tableData.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'canal/getField',
  mutationType: 'canal/updateField',
});

export default {
  name: 'CanalDatos',
  components: {
    appData: Data,
    appMensaje: Mensaje,
  },
  mixins: [
    msjModal, 
  ],
  data: () => {
    return {
      canalId: 0,
    }
  },
  computed: {
    ...mapFields([
      'canalDatos',
    ]),
  },  
  created() {
    this.canalId= this.$route.params.id

    this.$store.dispatch('canal/getDatos', this.canalId)
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    goList() {
      this.$router.push({ name: 'Canales' }); 
    },
    editar() {
      this.$router.push({ name: 'CanalEdit', 
                          params: { id: this.canalId }})
    },
  }
}
</script>
